import {
    IDatiqOption,
    IDatiqOptionRecordModel,
    generateOption,
    IDatiqChecklistItem
} from '@dat/datiq-components-pkg/utils';
import { Arbitrary, array, nat, record } from 'fast-check';

const subOptionsArb: Arbitrary<IDatiqOption[]> = array(generateOption());
const selectedOptionArb: Arbitrary<IDatiqOption> = subOptionsArb.chain(
    (subOptions: IDatiqOption[]) =>
        // will return undefined if subOptions is empty, which is expected (orr.epstein)
        nat(subOptions.length).map((index: number) => subOptions[index])
);
export const generateChecklistIitem: () => Arbitrary<IDatiqChecklistItem> =
    () => {
        return record(
            {
                ...IDatiqOptionRecordModel,
                subOptions: subOptionsArb,
                selectedOption: selectedOptionArb,
            },
            {
                requiredKeys: ['display', 'value'],
            }
        );
    };
